module.exports = __webpack_public_path__ + "static/media/Image_icon.683bf8da.svg";